import React, { useState } from "react";
import SupportModal from "../../Welcome/components/SupportModal";

const SchedulingSettingsHeader = ({ title, setOpaque, button, onBtnClick }) => {
  const [openSupport, setOpenSupport] = useState(false);
  const onSupport = () => {
    setOpenSupport(true);
    setOpaque && setOpaque(true);
  };
  const onCloseSupport = () => {
    setOpenSupport(false);
    setOpaque && setOpaque(false);
  };
  return (
    <div className="flex flex-row items-center justify-between h-20 p-4 border-b-[1px] border-b-secondarygrayborder">
      <div className="flex flex-row items-center justify-start gap-3">
        <p className="m-0 text-2xl font-bold text-gray-600">{title}</p>
      </div>
      <div>
        {button && <button
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          onClick={onBtnClick}
        >
          <span >{button}</span>
        </button>}
      </div>
      {openSupport && <SupportModal onCloseSupport={onCloseSupport} />}
    </div>
  );
};

export default SchedulingSettingsHeader;
